import React, { useEffect } from "react"
import { Form, Button, TimePicker, Row, Col } from "antd"
import { PlusOutlined } from "@ant-design/icons"
import { useTranslation } from "react-i18next"
import { Icon } from "ui/Icon"
import { Text } from "ui/Typography"
import { colors } from "themes/variables"

export const TimeBlockForm = ({ form }) => {
  const { t } = useTranslation()

  useEffect(() => {
    const currentValues = form.getFieldValue("available_hours")

    if (!currentValues || currentValues.length === 0) {
      form.setFieldsValue({
        available_hours: [{ start: null, end: null }]
      })
    }
  }, [form])

  const handleAdd = () => {
    const currentTimeBlocks = form.getFieldValue("available_hours") || []

    if (currentTimeBlocks.length > 0) {
      const lastTimeBlock = currentTimeBlocks[currentTimeBlocks.length - 1]

      if (lastTimeBlock.start && lastTimeBlock.end) {
        form.setFieldsValue({
          available_hours: [
            ...currentTimeBlocks,
            {
              start: lastTimeBlock.start.clone(),
              end: lastTimeBlock.end.clone()
            }
          ]
        })
        return
      }
    }

    const { add } = form.getFieldValue("available_hours") || {}
    if (add) add()
  }

  return (
    <>
      <Text className="block mb-s" fw="500">
        {t("experiences.scheduling.labels.time_blocks")}
      </Text>
      <Form.List name="available_hours">
        {(fields, { add, remove }) => (
          <>
            {fields.map(({ key, name, ...restField }) => {
              return (
                <Row key={key} gutter={16} align="middle">
                  <Col span={10}>
                    <Form.Item
                      {...restField}
                      name={[name, "start"]}
                      rules={[{ required: true, message: t("experiences.scheduling.errors.start_time") }]}
                    >
                      <TimePicker size="large" use12Hours format="hh:mm a" placeholder="Start Time" style={{ width: "100%" }} />
                    </Form.Item>
                  </Col>
                  <Col span={10}>
                    <Form.Item
                      {...restField}
                      name={[name, "end"]}
                      rules={[{ required: true, message: t("experiences.scheduling.errors.end_time") }]}
                    >
                      <TimePicker size="large" use12Hours format="hh:mm a" placeholder="End Time" style={{ width: "100%" }} />
                    </Form.Item>
                  </Col>
                  <Col span={4}>
                    <Icon
                      className="mb-m"
                      name="Trash"
                      color={colors.textSecondary}
                      width={20}
                      height={20}
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        if (fields.length > 1) {
                          remove(name)
                        }
                      }}
                    />
                  </Col>
                </Row>
              )
            })}
            <Form.Item>
              <Button
                type="link"
                onClick={() => {
                  const currentValues = form.getFieldValue("available_hours") || []
                  if (currentValues.length > 0) {
                    handleAdd()
                  } else {
                    add()
                  }
                }}
                icon={<PlusOutlined />}
              >
                {t("experiences.scheduling.labels.add_time_blocks")}
              </Button>
            </Form.Item>
          </>
        )}
      </Form.List>
    </>
  )
}
